export default {"src":"/fly/_next/static/media/ar.23c60625.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};